import React from "react";
import { Arrow, Container, Dismiss } from "./styles";
import InlineSVG from "react-inlinesvg";

const Tip = ({ dismiss, children }) => {
  return (
    <Container>
      {children}
      <Arrow />

      <Dismiss
        onClick={(e) => {
          dismiss();
        }}
      >
        <InlineSVG width={15} height={15} src="/assets/x.svg" />
      </Dismiss>
    </Container>
  );
};

export default Tip;
